import axios from 'axios';
import global from '../global';

export default axios.create({
  baseURL: global.url
});
